import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import {AppAlertService, SubtitlesService, UserService} from "../core";


@Component({
  selector: 'app-change-account-email',
  templateUrl: './change-account-email-controller.component.html',
  styleUrls: ['./change-account-email-controller.component.scss']
})
export class ChangeAccountEmailController implements OnInit {
  constructor(
      private location: Location,
      private http: HttpClient,
      private appAlert: AppAlertService,
      private subtitles: SubtitlesService,
      private user: UserService
  ) {}

  ngOnInit(): void {
    this.confirmEmailChange();
  }

  reload(): void {
    window.location.href = '/';
  }

  confirmEmailChange(): void {
    const uuid = this.location.path().split(/[=&]/)[1];

    this.http.put(`/api/v1/users/${this.user.user_id}/email/confirmation/${uuid}`,{})
        .subscribe({
            next: () => {
              this.appAlert.showAppAlert(
                  this.subtitles.setSubtitle(1444),
                  this.subtitles.setSubtitle(475),
                  () => this.reload(),
                  false,
                  null
              );
            },
            error:(response) => {
              if (response.status === 422 && response.error.code === -1) {
                this.appAlert.showAppAlert(
                    this.subtitles.setSubtitle(3650),
                    this.subtitles.setSubtitle(475),
                    () => this.reload(),
                    false,
                    null
                );
              } else {
                this.appAlert.showAppAlert(
                    this.subtitles.setSubtitle(1941),
                    this.subtitles.setSubtitle(1136),
                    null,
                    false,
                    null
                );
              }
            }
            }
        );
  }
}